import { ColumnRenderType, ColumnsType } from '@components/Table';
import { getTableColumnSortParams } from '@components/Table/Sorting/utils/getTableColumnSortParams';
import { translate } from '@chaika/i18n/helper';

export interface OrganizationRow {
    id: string;
    name: string;
    storeId: string;
}

interface Data {
    columns: ColumnsType<OrganizationRow>;
}

export function useColumns(): Data {
    const { defaultSortColumnParams } = getTableColumnSortParams();

    const columns: ColumnsType<OrganizationRow> = [
        {
            title: translate('nameSecond'),
            dataIndex: 'name',
            key: 'name',
            width: 400,
            renderType: ColumnRenderType.Truncated,
            ...defaultSortColumnParams,
            defaultSortOrder: 'ascend',
            sorter: (a, b) => a.name.localeCompare(b.name),
        },
        {
            title: 'Store ID',
            dataIndex: 'storeId',
            key: 'storeId',
            width: 400,
            renderType: ColumnRenderType.Truncated,
        },
    ];

    return { columns };
}
